import { useEffect, useMemo, useState } from 'react';
import { GigyaAccount, GigyaAuthConfig, GigyaAuthService } from '@comfama/frontend-utils';
 
export const useGigyaService = (config: GigyaAuthConfig) => {
    // Memorizamos la instancia para que sea única
    const service = useMemo(() => new GigyaAuthService(config), [config.apiKey]);
    const [account, setAccount] = useState<GigyaAccount | undefined>(service.getCurrentAccount());
    const [isLoading, setIsLoading] = useState(true);
 
    useEffect(() => {
        const handleUpdate = (event: any) => {
            setAccount(event.detail);
            setIsLoading(false);
        };
 
        window.addEventListener('gigyaAccountUpdated', handleUpdate);
        // Sincronización inicial por si el script ya cargó
        if (service.isScriptReady()) {
            setAccount(service.getCurrentAccount());
            setIsLoading(service.isLoadingAccount());
        }
 
        return () => window.removeEventListener('gigyaAccountUpdated', handleUpdate);
    }, [service]);
 
    return {
        account,
        isLoading,
        login: () => service.login(),
        logout: () => service.logout(),
        service // Por si necesitas métodos específicos como updateProfile
    };
};